import moment from 'moment'
import update from 'immutability-helper'
import { URIS } from '../Uris'
import { uiConstants } from '../constants'

import attraversamentoGreen from '../assets/markers/attraversamento_green.svg'
import attraversamentoYellow from '../assets/markers/attraversamento_yellow.svg'
import attraversamentoOrange from '../assets/markers/attraversamento_orange.svg'
import attraversamentoRed from '../assets/markers/attraversamento_red.svg'
import avvallamentoGreen from '../assets/markers/avvallamento_green.svg'
import avvallamentoYellow from '../assets/markers/avvallamento_yellow.svg'
import avvallamentoOrange from '../assets/markers/avvallamento_orange.svg'
import avvallamentoRed from '../assets/markers/avvallamento_red.svg'
import bucaGreen from '../assets/markers/buca_green.svg'
import bucaYellow from '../assets/markers/buca_yellow.svg'
import bucaOrange from '../assets/markers/buca_orange.svg'
import bucaRed from '../assets/markers/buca_red.svg'
import chiusinoGreen from '../assets/markers/chiusino_green.svg'
import chiusinoYellow from '../assets/markers/chiusino_yellow.svg'
import chiusinoOrange from '../assets/markers/chiusino_orange.svg'
import chiusinoRed from '../assets/markers/chiusino_red.svg'
import dossoGreen from '../assets/markers/dosso_green.svg'
import dossoYellow from '../assets/markers/dosso_yellow.svg'
import dossoOrange from '../assets/markers/dosso_orange.svg'
import dossoRed from '../assets/markers/dosso_red.svg'
import generalGreen from '../assets/markers/general_green.svg'
import generalYellow from '../assets/markers/general_yellow.svg'
import generalOrange from '../assets/markers/general_orange.svg'
import generalRed from '../assets/markers/general_red.svg'
import gibbositaGreen from '../assets/markers/gibbosita_green.svg'
import gibbositaYellow from '../assets/markers/gibbosita_yellow.svg'
import gibbositaOrange from '../assets/markers/gibbosita_orange.svg'
import gibbositaRed from '../assets/markers/gibbosita_red.svg'
import giuntoGreen from '../assets/markers/giunto_green.svg'
import giuntoYellow from '../assets/markers/giunto_yellow.svg'
import giuntoOrange from '../assets/markers/giunto_orange.svg'
import giuntoRed from '../assets/markers/giunto_red.svg'
import percorrenzaGreen from '../assets/markers/percorrenza_green.svg'
import percorrenzaYellow from '../assets/markers/percorrenza_yellow.svg'
import percorrenzaOrange from '../assets/markers/percorrenza_orange.svg'
import percorrenzaRed from '../assets/markers/percorrenza_red.svg'
import porfidoGreen from '../assets/markers/porfido_green.svg'
import porfidoYellow from '../assets/markers/porfido_yellow.svg'
import porfidoOrange from '../assets/markers/porfido_orange.svg'
import porfidoRed from '../assets/markers/porfido_red.svg'
import radiceGreen from '../assets/markers/radice_green.svg'
import radiceYellow from '../assets/markers/radice_yellow.svg'
import radiceOrange from '../assets/markers/radice_orange.svg'
import radiceRed from '../assets/markers/radice_red.svg'
import rappezzoGreen from '../assets/markers/rappezzo_green.svg'
import rappezzoYellow from '../assets/markers/rappezzo_yellow.svg'
import rappezzoOrange from '../assets/markers/rappezzo_orange.svg'
import rappezzoRed from '../assets/markers/rappezzo_red.svg'
import rotaiaGreen from '../assets/markers/rotaia_green.svg'
import rotaiaYellow from '../assets/markers/rotaia_yellow.svg'
import rotaiaOrange from '../assets/markers/rotaia_orange.svg'
import rotaiaRed from '../assets/markers/rotaia_red.svg'
import scavoGreen from '../assets/markers/scavo_green.svg'
import scavoYellow from '../assets/markers/scavo_yellow.svg'
import scavoOrange from '../assets/markers/scavo_orange.svg'
import scavoRed from '../assets/markers/scavo_red.svg'
import screpolaturaGreen from '../assets/markers/screpolatura_green.svg'
import screpolaturaYellow from '../assets/markers/screpolatura_yellow.svg'
import screpolaturaOrange from '../assets/markers/screpolatura_orange.svg'
import screpolaturaRed from '../assets/markers/screpolatura_red.svg'
import tombinoGreen from '../assets/markers/tombino_green.svg'
import tombinoYellow from '../assets/markers/tombino_yellow.svg'
import tombinoOrange from '../assets/markers/tombino_orange.svg'
import tombinoRed from '../assets/markers/tombino_red.svg'
import tracciaGreen from '../assets/markers/traccia_green.svg'
import tracciaYellow from '../assets/markers/traccia_yellow.svg'
import tracciaOrange from '../assets/markers/traccia_orange.svg'
import tracciaRed from '../assets/markers/traccia_red.svg'
import altroGreen from '../assets/markers/altro_green.svg'
import altroYellow from '../assets/markers/altro_yellow.svg'
import altroOrange from '../assets/markers/altro_orange.svg'
import altroRed from '../assets/markers/altro_red.svg'
import crepaGreen from '../assets/markers/crepa_green.svg'
import crepaYellow from '../assets/markers/crepa_yellow.svg'
import crepaOrange from '../assets/markers/crepa_orange.svg'
import crepaRed from '../assets/markers/crepa_red.svg'

import photo from '../assets/markers/photo.svg'
import photoCertified from '../assets/markers/photo_certified.svg'
import photoRepaired from '../assets/markers/photo_repaired.svg'

import repaired from '../assets/markers/repaired.svg'

import status0 from '../assets/markers/status_0.svg'
import status1 from '../assets/markers/status_1.svg'
import status2 from '../assets/markers/status_2.svg'
import status3 from '../assets/markers/status_3.svg'

export const holeHelper = {
  colorStatus,
  formFilters,
  imageMarker,
  calculateDistance,
  holeMarker,
  photoMarker,
  groupImages,
  holeStatusMarker
}

function photoMarker(image) {
  if (image.repaired === 1) {
    return photoRepaired
  } else {
    switch (image.certified) {
      case 1:
        return photoCertified
      default:
        return photo
    }
  }
}

function holeStatusMarker(hole) {
  switch (hole.status) {
    case 1:
      return status1
    case 2:
      return status2
    case 3:
      return status3
    default:
      return status0
  }
}

function holeMarker(hole, blue = true) {
  const v = hole.severity
  let t = hole.anomalyType
  let c = ''

  if (blue) {
    if (hole.status === 3) {
      return repaired
    }
  }

  switch (v) {
    case 1:
      c = 'green'
      break
    case 2:
      c = 'yellow'
      break
    case 3:
      c = 'orange'
      break
    default:
      c = 'red'
      break
  }
  if (t === '') {
    t = 'general'
  }

  switch (t + '_' + c) {
    case 'attraversamento_green':
      return attraversamentoGreen
    case 'attraversamento_orange':
      return attraversamentoOrange
    case 'attraversamento_red':
      return attraversamentoRed
    case 'attraversamento_yellow':
      return attraversamentoYellow
    case 'avvallamento_green':
      return avvallamentoGreen
    case 'avvallamento_orange':
      return avvallamentoOrange
    case 'avvallamento_red':
      return avvallamentoRed
    case 'avvallamento_yellow':
      return avvallamentoYellow
    case 'buca_green':
      return bucaGreen
    case 'buca_orange':
      return bucaOrange
    case 'buca_red':
      return bucaRed
    case 'buca_yellow':
      return bucaYellow
    case 'chiusino_green':
      return chiusinoGreen
    case 'chiusino_orange':
      return chiusinoOrange
    case 'chiusino_red':
      return chiusinoRed
    case 'chiusino_yellow':
      return chiusinoYellow
    case 'dosso_green':
      return dossoGreen
    case 'dosso_orange':
      return dossoOrange
    case 'dosso_red':
      return dossoRed
    case 'dosso_yellow':
      return dossoYellow
    case 'general_green':
      return generalGreen
    case 'general_orange':
      return generalOrange
    case 'general_red':
      return generalRed
    case 'general_yellow':
      return generalYellow
    case 'gibbosita_green':
      return gibbositaGreen
    case 'gibbosita_orange':
      return gibbositaOrange
    case 'gibbosita_red':
      return gibbositaRed
    case 'gibbosita_yellow':
      return gibbositaYellow
    case 'giunto_green':
      return giuntoGreen
    case 'giunto_orange':
      return giuntoOrange
    case 'giunto_red':
      return giuntoRed
    case 'giunto_yellow':
      return giuntoYellow
    case 'percorrenza_green':
      return percorrenzaGreen
    case 'percorrenza_orange':
      return percorrenzaOrange
    case 'percorrenza_red':
      return percorrenzaRed
    case 'percorrenza_yellow':
      return percorrenzaYellow
    case 'porfido_green':
      return porfidoGreen
    case 'porfido_orange':
      return porfidoOrange
    case 'porfido_red':
      return porfidoRed
    case 'porfido_yellow':
      return porfidoYellow
    case 'radice_green':
      return radiceGreen
    case 'radice_orange':
      return radiceOrange
    case 'radice_red':
      return radiceRed
    case 'radice_yellow':
      return radiceYellow
    case 'rappezzo_green':
      return rappezzoGreen
    case 'rappezzo_orange':
      return rappezzoOrange
    case 'rappezzo_red':
      return rappezzoRed
    case 'rappezzo_yellow':
      return rappezzoYellow
    case 'rotaia_green':
      return rotaiaGreen
    case 'rotaia_orange':
      return rotaiaOrange
    case 'rotaia_red':
      return rotaiaRed
    case 'rotaia_yellow':
      return rotaiaYellow
    case 'scavo_green':
      return scavoGreen
    case 'scavo_orange':
      return scavoOrange
    case 'scavo_red':
      return scavoRed
    case 'scavo_yellow':
      return scavoYellow
    case 'screpolatura_green':
      return screpolaturaGreen
    case 'screpolatura_orange':
      return screpolaturaOrange
    case 'screpolatura_red':
      return screpolaturaRed
    case 'screpolatura_yellow':
      return screpolaturaYellow
    case 'tombino_green':
      return tombinoGreen
    case 'tombino_orange':
      return tombinoOrange
    case 'tombino_red':
      return tombinoRed
    case 'tombino_yellow':
      return tombinoYellow
    case 'traccia_green':
      return tracciaGreen
    case 'traccia_orange':
      return tracciaOrange
    case 'traccia_red':
      return tracciaRed
    case 'traccia_yellow':
      return tracciaYellow
    case 'altro_green':
      return altroGreen
    case 'altro_orange':
      return altroOrange
    case 'altro_red':
      return altroRed
    case 'altro_yellow':
      return altroYellow
    case 'crepa_green':
      return crepaGreen
    case 'crepa_orange':
      return crepaOrange
    case 'crepa_red':
      return crepaRed
    case 'crepa_yellow':
      return crepaYellow
    default:
      return generalGreen
  }
}

function colorStatus(status) {
  switch (status) {
    case 1:
      return 'yellow'
    case 2:
      return 'green'
    default:
      return 'red'
  }
}

function formFilters(s) {
  let pq = []
  s.formFilters.forEach((f) => {
    let value = f.value
    // console.log(f)
    if (value !== '' || f.type === 'severity') {
      if (f.type === 'date' || f.type === 'photo_date') {
        value = moment(value).utc().add(moment().utcOffset(), 'minutes').unix()
      }
      if (f.type === 'severity') {
        const arr = []
        if (s.red) {
          arr.push(4)
        }
        if (s.orange) {
          arr.push(3)
        }
        if (s.yellow) {
          arr.push(2)
        }
        if (s.green) {
          arr.push(1)
        }
        value = arr.join(',')
      }
      pq = update(pq, {
        $push: [
          {
            id: f.filterid,
            matcher: f.matcher,
            value
          }
        ]
      })
    }
  })
  return pq
}

function imageMarker(guid, q = 0) {
  const b = `${URIS.cdn.photos}/${guid}/`
  switch (q) {
    case uiConstants.imageQuality.low:
      return b + 'low.jpg'
    case uiConstants.imageQuality.medium:
      return b + 'medium.jpg'
    case uiConstants.imageQuality.high:
      return b + 'high.jpg'
    default:
      return b + 'marker.jpg'
  }
}

function calculateDistance(lat1, lon1, lat2, lon2) {
  if (lat1 === lat2 && lon1 === lon2) {
    return 0
  } else {
    var radlat1 = (Math.PI * lat1) / 180
    var radlat2 = (Math.PI * lat2) / 180
    var theta = lon1 - lon2
    var radtheta = (Math.PI * theta) / 180
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
    if (dist > 1) {
      dist = 1
    }
    dist = Math.acos(dist)
    dist = (dist * 180) / Math.PI
    dist = dist * 60 * 1.1515
    return dist * 1.609344
  }
}

function groupImages(arr) {
  // var helper = {}
  // var result = arr.reduce((r, o) => {
  //   var key = o.latitude + '-' + o.longitude
  //   if (!helper[key]) {
  //     helper[key] = Object.assign({}, o)
  //     r.push(helper[key])
  //   } else {
  //     helper[key].used += o.used
  //     helper[key].instances += o.instances
  //   }
  //   return r
  // }, [])
  // return result
  // return arr.sort((a, b) => (a.mediadate > b.mediadate) ? 1 : -1)
}
